module.exports = __webpack_public_path__ + "img/close.f795b306.png";